import IMask from 'imask';

export default class Forms {
    constructor() {}

    static serializeJSON(form) {
        const formData = new FormData(form);

        const pairs = {};

        for (const [name, value] of formData) {
            pairs[name] = value;
        }

        return JSON.stringify(pairs, null, 2);
    }

    static wrongMessages() {
        let mensagens;
        if (document.documentElement.lang === 'pt-BR') {
            mensagens = {
                messages: {
                    missingValue: {
                        checkbox: 'Este campo é obrigatório.',
                        radio: 'Por favor selecione um valor.',
                        select: 'Por favor selecione um valor.',
                        'select-multiple': 'Por favor selecione pelo menos um valor.',
                        default: 'Por favor preencha este campo',
                    },
                    patternMismatch: {
                        email: 'Insira um endereço de e-mail corporativo válido.',
                        url: 'Informe uma url.',
                        number: 'Informe o telefone',
                        date: 'Por favor utilizar o formato DD/MM/YYYY',
                        default: 'Por favor, preencha o campo com conteúdo válido.',
                    },
                    outOfRange: {
                        over: 'Selecione um valor que não seja superior a {max}.',
                        under: 'Selecione um valor que não seja inferior a {min}.',
                    },
                    wrongLength: {
                        over: 'Reduza este texto para não mais que {maxLength} caracteres. VocÃª está usando atualmente {length} caracteres.',
                        under: 'Por favor, estenda este texto para {minLength} caracteres ou mais. VocÃª está usando atualmente {length} caracteres.',
                    },
                },
            };
        } else {
            mensagens = {
                messages: {
                    missingValue: {
                        checkbox: 'This field is required.',
                        radio: 'Please select a value.',
                        select: 'Please select a value.',
                        'select-multiple': 'Please select at least one value.',
                        default: 'Please fill in this field',
                    },
                    patternMismatch: {
                        email: 'Enter a valid company email address.',
                        url: 'Enter a url.',
                        number: 'Inform the phone',
                        date: 'Please use the format DD/MM/YYYY',
                        default: 'Please fill in the field with valid content.',
                    },
                    outOfRange: {
                        over: 'Please select a value that is no more than {max}.',
                        under: 'Please select a value that is no less than {min}.',
                    },
                    wrongLength: {
                        over: 'Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.',
                        under: 'Please lengthen this text to {minLength} characters or more. You are currently using {length} characters.',
                    },
                },
            };
        }
        return mensagens;
    }

    // static validarEmail(email) {
    //     // Lista de domÃ­nios bloqueados
    //     const dominiosBloqueados = ['gmail.com', 'yahoo.com', 'bing.com', 'hotmail.com', 'outlook.com', 'live.com', 'aol.com', 'icloud.com', 'ymail.com', 'msn.com', 'uol.com.br', 'terra.com.br', 'ig.com.br'];

    //     // Extrai o domÃ­nio do e-mail fornecido
    //     const dominio = email.split('@')[1];

    //     // Verifica se o domÃ­nio está na lista de domÃ­nios bloqueados
    //     if (dominiosBloqueados.includes(dominio)) {
    //       return false; // E-mail Ã© de um domÃ­nio bloqueado
    //     }

    //     // Verifica se o e-mail Ã© válido de acordo com o padrão
    //     const padraoEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //     return padraoEmail.test(email);
    // }

    static formDataToQueryString(formData) {
        const params = new URLSearchParams();
        for (const pair of formData.entries()) {
            params.append(pair[0], pair[1]);
        }
        return params.toString();
    }

    static maskField() {
        const phoneField = document.querySelectorAll('.telMask');
        const dateField = document.querySelectorAll('.dateMask');

        if (phoneField) {
            phoneField.forEach((field) => {
                let phoneMask = IMask(field, {
                    mask: '(00) 00000-0000',
                });
            });
        }

        if (dateField) {
            dateField.forEach((field) => {
                let dateMask = IMask(field, {
                    mask: Date,

                    pattern: 'd/`m/`Y',
                    blocks: {
                        d: {
                            mask: IMask.MaskedRange,
                            from: 1,
                            to: 31,
                        },
                        m: {
                            mask: IMask.MaskedRange,
                            from: 1,
                            to: 12,
                        },
                        Y: {
                            mask: IMask.MaskedRange,
                            from: 19000,
                            to: 20290,
                        },
                    },
                });
            });
        }
    }
}
